import './public-path';
import { BrowserModule } from '@angular/platform-browser';
import { CommonModule } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { NgxElementModule, LazyComponentRegistry, createDef, LAZY_CMPS_REGISTRY } from '@eg-brs/eg.ng.element';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { AuthInterceptor } from './interceptors/auth.interceptor';
import { CaseConvertInterceptor } from './interceptors/case-convert.interceptor';
import { ErrorInterceptor } from './interceptors/error.interceptor';
import { MappingInterceptor } from './interceptors/mapping.interceptor';
import { PopupService } from './services/popup/popup.service';
import { RateLimitInterceptor } from './interceptors/rate-limit.interceptor';

const lazyComponentRegistry: LazyComponentRegistry = {
  definitions: [
    createDef('cost-post-list', () => import('./modules/cost-post-list/cost-post-list.module').then(m => m.CostPostListModule)),
    createDef('create-fiscal', () => import('./modules/create-fiscal/create-fiscal.module').then(m => m.CreateFiscalModule)),
    createDef('default-price-margin', () => import('./modules/default-price-margin/default-price-margin.module').then(m => m.DefaultPriceMarginModule)),
    createDef('document-preview', () => import('./modules/document-preview/document-preview.module').then(m => m.DocumentPreviewModule)),
    createDef('fiscal-approval-settings', () => import('./modules/fiscal-approval-settings/fiscal-approval-settings.module').then(m => m.FiscalApprovalSettingsModule)),
    createDef('import-csv-cost-registration', () => import('./modules/import-csv-cost-registration/import-csv.module').then(m => m.ImportCsvModule)),
    createDef('import-saf-t', () => import('./modules/import-saf-t/import-saf-t.module').then(m => m.ImportSafTModule)),
    createDef('nem-handel', () => import('./modules/nem-handel/nem-handel.module').then(m => m.NemHandelModule)),
    createDef('popup-example', () => import('./modules/popup-example/popup-example.module').then(m => m.PopupExampleModule)),
    createDef('recalculate-sales-prices', () => import('./modules/recalculate-sales-prices/recalculate-sales-prices.module').then(m => m.RecalculateSalesPricesModule)),
    createDef('smtp-settings', () => import('./modules/smtp-settings/smtp-settings.module').then(m => m.SmtpSettingsModule)),
    createDef('support-user-membership-list', () => import('./modules/support-user-membership-list/support-user-membership-list.module').then(m => m.SupportUserMembershipListModule)),
    createDef('user-notification', () => import('./modules/user-notification/user-notification.module').then(m => m.UserNotificationModule)),
    createDef('snippet', () => import('./modules/snippet/snippet.module').then(m => m.SnippetModule)),
    createDef('translate-app', () => import('./modules/translate-app/translate-app.module').then(m => m.TranslateAppModule)),
  ],
  useCustomElementNames: true,
  customElementNamePrefix: 'xwc'
};

export function lazyComponentRegistryFactory() {
  return lazyComponentRegistry;
}



@NgModule({ schemas: [CUSTOM_ELEMENTS_SCHEMA], imports: [CommonModule,
        BrowserModule,
        NgxElementModule], providers: [
        { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },
        { provide: HTTP_INTERCEPTORS, useClass: CaseConvertInterceptor, multi: true },
        { provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true },
        { provide: HTTP_INTERCEPTORS, useClass: MappingInterceptor, multi: true },
        { provide: HTTP_INTERCEPTORS, useClass: RateLimitInterceptor, multi: true },
        { provide: LAZY_CMPS_REGISTRY, useFactory: lazyComponentRegistryFactory },
        PopupService,
        provideHttpClient(withInterceptorsFromDi())
    ] })
export class AppModule {
  ngDoBootstrap(): void { }
}
